import { useQuery } from "@tanstack/react-query";
import { fetchData } from "./UseStudentGetApi";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";


// export const useApartmentStuCount = (id) => {
//     return useQuery({
//         queryKey: ["apartment-student-count", id],
//         queryFn: () => fetchData(`student-count/${id}`),
//     });
// };

export const useApartmentCourses = (id) => {
    return useQuery({
        queryKey: ["apartment-course-details", id],
        queryFn: () => fetchDataNode(`apartment-course-details/${id}`),
    });
};

export const useApartmentPayout = () => {
    return useQuery({
        queryKey: ["student-payout-details"],
        queryFn: () => fetchDataNode(`student-payout-details`),
    });
};

export const useApartmentDetails = (filters) => {
    return useQuery({
        queryKey: ["get-apartment-by-name", filters],
        queryFn: () => fetchDataNode(`get-apartment-by-name`, filters),
    });
};

export const useStudentCourseCount = (filters) => {
    return useQuery({
        queryKey: ["student-course-count", filters],
        queryFn: () => fetchDataNode(`student-course-count`, filters),
    });
};

export const useApproveStatusOfApartment = (filters) => {
    return useQuery({
        queryKey: ["apartment-approvals", filters],
        queryFn: () => fetchDataNode(`apartment-approvals`, filters),
    });
};
export const useApartmentAccountHistory = (filters) => {
    return useQuery({
        queryKey: ["apartment-account-history", filters],
        queryFn: () => fetchDataNode(`apartment-account-history`, filters),
    });
};

